import React, { useEffect } from "react";
import LZString from 'lz-string';
import $ from "jquery";
import Toastr from 'toastr';
import Hls from 'hls.js';
import logo from '../../assets/img/sitekick-header-logo.png';
import Loading from "../Loading";
import CommonUtils from '../../util/CommonUtils';
import API from '../../service/SiteKickAPIService';

let stream_token = {};
function AxisLiveStream(props) {

    stream_token = props.stream_token;
    let browserAgent = (navigator.userAgent).toUpperCase();
    let iOS = browserAgent.includes('IPAD') || browserAgent.includes('IPHONE');
    let streamPlayer = !iOS ? msePlayer : hlsPlayer;

    useEffect(() => {
        if (stream_token)
            fetchStreamInfo();
    }, []);

    const fetchStreamInfo = () => {
        CommonUtils.ajax({
            url: API.AXIS_CAMERA.STREAM_INFO,
            type: 'POST',
            contentType: "application/json; charset=utf-8",
            dataType: "json",
            headers: {
                user_login: stream_token.user_login,
                user_token: stream_token.user_token,
                user_type: 'user',
                'x-api-key': 'OIE3m9hJUI3egDNNU2mj1anJYK7FOJHm9J2DsznY'
            },
            data: JSON.stringify({ device_id: stream_token.device_id }),
            success: function (response) {
                streamPlayer();
            },
            error: function (xhr, status) {
                Toastr.error('No streaming information found');
            }
        });
    }

    function msePlayer() {
        const mseQueue = []
        let mseSourceBuffer
        let mseStreamingStarted = false;
        function Utf8ArrayToStr(array) {
            var out, i, len, c;
            var char2, char3;
            out = "";
            len = array.length;
            i = 0;
            while (i < len) {
                c = array[i++];
                switch (c >> 4) {
                    case 7:
                        out += String.fromCharCode(c);
                        break;
                    case 13:
                        char2 = array[i++];
                        out += String.fromCharCode(((c & 0x1F) << 6) | (char2 & 0x3F));
                        break;
                    case 14:
                        char2 = array[i++];
                        char3 = array[i++];
                        out += String.fromCharCode(((c & 0x0F) << 12) |
                            ((char2 & 0x3F) << 6) |
                            ((char3 & 0x3F) << 0));
                        break;

                    default:
                        break;
                }
            }
            return out;
        }

        function startPlay(videoEl, url) {
            const mse = new MediaSource()
            videoEl.src = window.URL.createObjectURL(mse)
            // mse.addEventListener("sourceopen", () => {
            //     setTimeout(() => {
            //         $("#axis-video").removeClass("hide");
            //     }, 5000);
            // });

            mse.addEventListener('sourceopen', function () {
                const ws = new WebSocket(url)
                ws.binaryType = 'arraybuffer'
                ws.onopen = function (event) {
                    console.log('Connect to ws')
                }
                ws.onmessage = function (event) {
                    const data = new Uint8Array(event.data)
                    if (data[0] === 9) {
                        let mimeCodec
                        const decodedArr = data.slice(1)
                        if (window.TextDecoder) {
                            mimeCodec = new TextDecoder('utf-8').decode(decodedArr)
                        } else {
                            mimeCodec = Utf8ArrayToStr(decodedArr)
                        }
                        mseSourceBuffer = mse.addSourceBuffer('video/mp4; codecs="' + mimeCodec + '"')
                        mseSourceBuffer.mode = 'segments'
                        mseSourceBuffer.addEventListener('updateend', pushPacket)
                    } else {
                        readPacket(event.data)
                    }
                }
            }, false)
        }

        function pushPacket() {
            const videoEl = document.querySelector('#axis-video')
            let packet

            if (!mseSourceBuffer.updating) {
                if (mseQueue.length > 0) {
                    packet = mseQueue.shift()
                    mseSourceBuffer.appendBuffer(packet)
                } else {
                    mseStreamingStarted = false
                }
            }
            if (videoEl && videoEl.buffered.length > 0) {
                if (typeof document.hidden !== 'undefined' && document.hidden) {
                    // no sound, browser paused video without sound in background
                    videoEl.currentTime = videoEl.buffered.end((videoEl.buffered.length - 1)) - 0.5
                }
            }
        }

        function readPacket(packet) {
            if (!mseStreamingStarted) {
                mseSourceBuffer.appendBuffer(packet)
                mseStreamingStarted = true
                return
            }
            mseQueue.push(packet)
            if (!mseSourceBuffer.updating) {
                pushPacket()
            }
        }
        const videoEl = document.querySelector('#axis-video');

        let uuid = LZString.compressToBase64(stream_token.user_login + " " + stream_token.user_token + " " + stream_token.user_type);
        const mseUrl = "wss://rtsp.sitesuptondemand.com/stream/" + (stream_token.device_id) + "/channel/0/mse?uuid=" + encodeURIComponent(uuid);

        // fix stalled video in safari
        videoEl.addEventListener('pause', () => {
            try {
                if (videoEl.currentTime > videoEl.buffered.end(videoEl.buffered.length - 1)) {
                    videoEl.currentTime = videoEl.buffered.end(videoEl.buffered.length - 1) - 0.1
                    videoEl.play()
                }
            } catch (error) { }
        })

        startPlay(videoEl, mseUrl)
    }

    function hlsPlayer() {
        let hls = null;
        if (hls == null && Hls.isSupported()) {
            hls = new Hls();
        }

        let uuid = LZString.compressToBase64(stream_token.user_login + " " + stream_token.user_token + " " + stream_token.user_type);
        const hlsUrl = "https://rtsp.sitesuptondemand.com/stream/" + (stream_token.device_id) + "/channel/0/hls/live/index.m3u8?uuid=" + encodeURIComponent(uuid);
        if ($("#axis-video")[0].canPlayType('application/vnd.apple.mpegurl')) {
            $("#axis-video")[0].src = hlsUrl;
            $("#axis-video")[0].load();
        } else {
            if (hls != null) {
                hls.loadSource(hlsUrl);
                hls.attachMedia($("#axis-video")[0]);
            } else {
                Toastr.error('Your browser is not support to paly the stream')
            }
        }
    }

    return <>
        <div>
            <a href='https://www.sitekick.com' target='_blank' rel="noopener noreferrer" className="bg-primary" style={{ position: 'fixed', zIndex: 1000, top: '10px', right: '10px', borderRadius: '2px', padding: '3px 0px 0px 4px' }}>
                <img className="pb-1" src={logo} alt="logo" style={{ width: "95px", marginRight: "10px" }} />
            </a>
            <div className="ant-modal-mask stream-mask d-flex justify-content-center" ><span className="align-self-center"><Loading >Loading ...</Loading></span></div>
            <video onPlay={() => { $(".stream-mask").addClass("hide"); $("#axis-video").width($("body").innerWidth()); }} id="axis-video" autoPlay muted playsInline controls style={{ "maxWidth": "100%", "maxHeight": "100%" }} ></video>
        </div>
    </>
}

export default AxisLiveStream;